<template>
  <div class="top-products">
    <!-- Skeleton -->
    <div v-if="loading" class="tp-skeleton">
      <div v-for="n in 5" :key="n" class="tp-skeleton-row">
        <div class="skeleton-rank"></div>
        <div class="skeleton-line w60"></div>
        <div class="skeleton-line w30"></div>
      </div>
    </div>

    <!-- List -->
    <div v-else-if="products.length" class="tp-list">
      <div
        v-for="(product, idx) in products"
        :key="product.id || idx"
        class="tp-item"
      >
        <div class="tp-rank">{{ idx + 1 }}</div>
        <div class="tp-info">
          <span class="tp-name">{{ product.name }}</span>
          <span class="tp-meta">{{ product.invoice_count }} facturas</span>
        </div>
        <FormatAmount :amount="product.total_invoiced" class="tp-amount" />
      </div>

      <div class="tp-footer">
        <button class="tp-ver-todos" @click="goToProductsReport">
          Ver todos <i class="el-icon-arrow-right"></i>
        </button>
      </div>
    </div>

    <!-- Empty -->
    <div v-else class="tp-empty">
      <i class="el-icon-goods"></i>
      <span>Sin datos de productos</span>
    </div>
  </div>
</template>

<script>
import dashboardService from "../services/dashboardService";
import FormatAmount from "@/components/General/FormatAmount";

export default {
  name: "TopProducts",
  components: { FormatAmount },
  props: {
    period: { type: String, default: "month" }
  },
  data() {
    return {
      loading: true,
      cache: {},
      products: []
    };
  },
  watch: {
    period: {
      immediate: true,
      handler(val) {
        this.fetchProducts(val);
      }
    }
  },
  methods: {
    async fetchProducts(period) {
      if (this.cache[period]) {
        this.products = this.cache[period];
        return;
      }

      this.loading = true;
      try {
        const res = await dashboardService.getTopProducts({
          params: { period, limit: 5 }
        });
        if (res.data && res.data.success) {
          this.products = res.data.data.products || res.data.data || [];
          this.cache[period] = this.products;
        }
      } catch (e) {
        // Mantener valores actuales
      } finally {
        this.loading = false;
      }
    },
    goToProductsReport() {
      this.$router.push({ name: "reports", query: { tab: "products" } });
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$accent: #3fdbbf;
$border: #e4eaf6;
$bg: #f7f8f9;

.top-products {
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
  padding: 18px;
}
.tp-list {
  display: flex;
  flex-direction: column;
}
.tp-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid $border;
  &:last-child {
    border-bottom: none;
  }
}
.tp-rank {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: $bg;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: $primary;
  flex-shrink: 0;
}
.tp-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.tp-name {
  font-size: 13px;
  font-weight: 500;
  color: $primary;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tp-meta {
  font-size: 12px;
  color: #909399;
}
.tp-amount {
  font-size: 13px;
  font-weight: 500;
  color: $primary;
  flex-shrink: 0;
}

.tp-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
}

.tp-ver-todos {
  background: none;
  border: none;
  color: $accent;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 3px;
  transition: opacity 0.15s;
  &:hover {
    opacity: 0.75;
  }
  i {
    font-size: 11px;
  }
}

.tp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  color: #c0c4cc;
  gap: 8px;
  i {
    font-size: 28px;
  }
  span {
    font-size: 12px;
  }
}

// Skeleton
.tp-skeleton {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.tp-skeleton-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.skeleton-rank {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f2f7 25%, #e8ecf5 50%, #f0f2f7 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
}
.skeleton-line {
  height: 12px;
  background: linear-gradient(90deg, #f0f2f7 25%, #e8ecf5 50%, #f0f2f7 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  &.w30 {
    width: 30%;
  }
  &.w60 {
    width: 60%;
  }
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
